<nb-card>
  <nb-card-body>
    <div class="table-responsive">
      <ng2-smart-table
        [settings]="settings"
        [source]="source"
        (userRowSelect)="selectedItem($event)"
      >
      </ng2-smart-table>
      <strong class="text-hint">Tổng số: {{ source.count() }}</strong>
    </div>
  </nb-card-body>
</nb-card>
